jQuery(document).ready(function ($) {
  const body = $('body');
  const header = $('.site-header');

  $.fancybox.defaults.backFocus = false;

  // mobile menu
  let prevScrollPosition = 0;

  function openMobileMenu() {
    const menuLink = $('.site-header__menu-link');
    const mobileMenu = $('.mobile-menu');
    const menuBg = $('.menu-bg');

    prevScrollPosition = $(document).scrollTop();
    body.css('top', `-${prevScrollPosition}px`);
    menuLink.addClass('site-header__menu-link--opened');
    menuBg.stop(true, true).fadeIn(200);
    mobileMenu.stop(true, true).fadeIn(200);
  }

  function closeMobileMenu() {
    const menuLink = $('.site-header__menu-link');
    const mobileMenu = $('.mobile-menu');
    const menuBg = $('.menu-bg');

    $('html, body').scrollTop(prevScrollPosition);
    menuLink.removeClass('site-header__menu-link--opened');
    menuBg.stop(true, true).fadeOut(200);
    mobileMenu.stop(true, true).fadeOut(200);
  }

  body.on('click', '.js-toggleMenu', function (e) {
    e.preventDefault();

    if (!$(this).hasClass('site-header__menu-link--opened')) {
      openMobileMenu();
    } else {
      closeMobileMenu();
    }
  });

  body.on('click', '.js-closeMobileMenu', function (e) {
    e.preventDefault();

    closeMobileMenu();
  });

  // city select
  body.on('click', '.city-select__selected', function (e) {
    e.preventDefault();
    const select = $(this).closest('.city-select');
    const list = select.find('.city-select__list');

    list.stop(true, true).fadeToggle(200);
    select.toggleClass('city-select--opened');
  });

  body.on('click', function (e) {
    const citySelect = $('.city-select');
    if (citySelect.length && !citySelect.is(e.target) && citySelect.has(e.target).length === 0) {
      citySelect.find('.city-select__list').fadeOut(200);
      citySelect.removeClass('city-select--opened');
    }
  });

  // header search
  body.on('click', '.site-header__search-link', function (e) {
    e.preventDefault();
    const search = $(this).closest('.site-header__search');
    const searchPopup = search.find('.site-header__search-form');

    searchPopup.stop(true, true).fadeToggle(200);
    search.toggleClass('site-header__search--opened');
  });

  body.on('click', '.site-header__search-close', function (e) {
    e.preventDefault();
    const search = $(this).closest('.site-header__search');
    const searchPopup = search.find('.site-header__search-form');

    searchPopup.fadeOut(200);
    search.removeClass('site-header__search--opened');
  });

  body.on('click', '.js-scrollTo', function (e) {
    e.preventDefault();
    const target = $(this).data('target');
    const element = $(`.${target}`);
    const paddingTop = parseInt(element.css('padding-top'), 10);
    const offset = element.offset().top - (header.outerHeight() + (paddingTop > 0 ? 0 : 40));

    $('html, body').animate({
      scrollTop: offset
    }, 500);
  });

  body.on('click', '.js-cooperate', function (e) {
    e.preventDefault();
    const index = $(this).closest('.cooperation__block').index();

    body.find('[name="request[cooperation]"]').eq(index).trigger('click');

    $('html, body').animate({
      scrollTop: $('.form-block').offset().top - (header.outerHeight() + 40),
    }, 500);
  });

  // front page slider
  const mainSlider = new Swiper('.js-mainSlider', {
    slidesPerView: 1,
    spaceBetween:0,
    loop: true,
    navigation: {
      nextEl: '.js-nextMainSlide',
      prevEl: '.js-prevMainSlide',
    },
    pagination: {
      el: '.js-mainSliderDots',
      clickable: true,
    },
  });

  // file picker
  body.on('change', '.js-filePicker', function (e) {
    const filePicker = $(this).closest('.file-picker');
    const file = e.target.files[0];

    filePicker.addClass('file-picker--selected');
    filePicker.find('.file-picker__preview').text(file.name);
  });

  body.on('click', '.js-removeFile', function (e) {
    e.preventDefault();
    const filePicker = $(this).closest('.file-picker');

    filePicker.removeClass('file-picker--selected');
    filePicker.find('.file-picker__input').val('');
    filePicker.find('.file-picker__preview').text('');
  });

  // forms
  let formSubmitted = false;

  function checkFields(fields, ok) {
    fields.each(function () {
      const input = $(this);
      const field = input.closest('.field');

      if (!input.val().length) {
        ok = false;

        field.find('.field__error').fadeIn(200);
        field.addClass('field--error');
      }
    });

    return ok;
  }

  body.on('focus', '.field__input', function () {
    const field = $(this).closest('.field');

    field.removeClass('field--error');
    field.find('.field__error').fadeOut(200);
  });

  body.on('submit', '.js-form', function (e) {
    e.preventDefault();
    const form = $(this);
    const modal = form.closest('.custom-modal');
    const formData = new FormData(this);
    let ok = true;

    ok = checkFields(form.find('.js-requiredField'), ok);

    if (ok === true && formSubmitted === false) {
      formSubmitted = true;

      // ajax something
      /*
        $.ajax({
          type: "POST",
          url: form.attr('action'),
          processData: false,
          contentType: false,
          data: formData,
          success: function () {
            formSubmitted = false;
            form.trigger('reset');
          },
          error: function () {
            formSubmitted = false;
          },
        });
      */

      if (modal.length) {
        modal.find('.custom-modal__success').fadeIn(200);
      }

      setTimeout(function () {
        formSubmitted = false;
      }, 2000);
    }
  });

  body.on('click', '.js-toggleCategories', function (e) {
    e.preventDefault();
    const categories = $(this).closest('.categories');
    const list = categories.find('.categories__list');

    list.stop(true, true).slideToggle(200);
  });

  // contacts map
  const map = $('#map');

  if (map.length) {
    const isMobileView = window.matchMedia('(min-width: 0px) and (max-width: 991px)');
    let placemarks = [];

    $.ajax({
      type: "POST",
      url: '/ajax/placemarks.json',
      success: function (response) {
        placemarks = response;

        ymaps.ready(initContactsMap);
      },
    });

    function initContactsMap() {
      const collection = new ymaps.GeoObjectCollection(null, {
        preset: 'islands#yellowIcon'
      });

      const myMap = new ymaps.Map('map', {
        center: [57.1404992, 65.5548429],
        zoom: 12,
        controls: ['zoomControl'],
        autoFitToViewport: 'always',
      }, {
        zoomControlFloat: 'none',
        zoomControlPosition: {
          right: 10,
          top: 10
        },
        suppressMapOpenBlock: true,
      });

      const defaultOptions = {
        iconImageHref: '/assets/images/icons/default-placemark.svg',
        iconImageSize: [42, 48],
        iconImageOffset: [-21, -48],
      };

      const activeOptions = {
        iconImageHref: 'assets/images/icons/active-placemark.svg',
        iconImageSize: [42, 48],
        iconImageOffset: [-21, -48],
      };

      placemarks.map(({ id, address, coordinates }) => {
        const placemark = new ymaps.Placemark([Number(coordinates[0]), Number(coordinates[1])], {
          hintContent: address,
          defaultOptions,
          activeOptions,
          id,
        }, {
          iconLayout: 'default#image',
          iconImageHref: '/assets/images/icons/default-placemark.svg',
          iconImageSize: [42, 48],
          iconImageOffset: [-21, -48],
        });
        collection.add(placemark);
      });

      collection.get(0).options.set(collection.get(0).properties.get('activeOptions'));

      collection.events.add('click', function (e) {
        const shops = $('.contacts__shop');
        const activeGeoObject = e.get('target');
        const objectId = activeGeoObject.properties.get('id');
        const selectedShop = $(`.contacts__shop[data-id="${objectId}"]`);
        activeGeoObject.options.set(activeGeoObject.properties.get('activeOptions'));

        shops.removeClass('contacts__shop--selected');
        selectedShop.addClass('contacts__shop--selected');

        if (isMobileView.matches) {
          const offset = selectedShop.offset().top - header.outerHeight();

          $('html, body').animate({
            scrollTop: offset
          }, 500);
        }

        collection.each(function (geoObject) {
          if (geoObject !== activeGeoObject) {
            geoObject.options.set(geoObject.properties.get('defaultOptions'));
          }
        });
      });

      myMap.behaviors.disable(['scrollZoom']);
      myMap.geoObjects.add(collection);
      myMap.setBounds(collection.getBounds(), {
        checkZoomRange: true,
        zoomMargin: 20,
      }).then(function(){
        if(myMap.getZoom() > 14) myMap.setZoom(14);
      });

      body.on('click', '.contacts__shop', function (e) {
        e.preventDefault();
        const item = $(this);
        const markId = item.data('id');

        if (item.hasClass('contacts__shop--selected')) {
          return false;
        }

        $('.contacts__shop').removeClass('contacts__shop--selected');
        item.addClass('contacts__shop--selected');

        if (isMobileView.matches) {
          const offset = map.offset().top - header.outerHeight();

          $('html, body').animate({
            scrollTop: offset
          }, 500);
        }

        collection.each(function (geoObject) {
          if (geoObject.properties.get('id') === markId) {
            geoObject.options.set(geoObject.properties.get('activeOptions'));
          } else {
            geoObject.options.set(geoObject.properties.get('defaultOptions'));
          }
        });
      });
    }
  }

  // project slider
  const projectSlider = new Swiper('.js-projectSlider', {
    slidesPerView: "auto",
    spaceBetween: 10,
    centeredSlides: true,
    roundLengths: true,
    loop: true,
    loopAdditionalSlides: 3,
    navigation: {
      nextEl: '.js-nextProjectSlide',
      prevEl: '.js-prevProjectSlide',
    },
    pagination: {
      el: '.js-projectSliderDots',
      clickable: true,
    },
    breakpoints: {
      "768": {
        spaceBetween: 110,
      },
    },
  });

  // categories slider
  const popularCategories = new Swiper('.js-popularCategories', {
    slidesPerView: "auto",
    spaceBetween: 0,
  });

  $(window).on('load', function () {
    const categories = $('.categories-slider');
    if (categories.length) {
      popularCategories.update();
    }
  });

  // product gallery
  const productThumbnails = new Swiper('.js-productThumbnails', {
    slidesPerView: 'auto',
    spaceBetween: 15,
    watchSlidesProgress: true,
    slideToClickedSlide: true,
    breakpoints: {
      '992': {
        spaceBetween: 30,
      },
    },
  });

  const productPhotos = new Swiper('.js-productPhotos', {
    spaceBetween: 10,
    slidesPerView: 1,
    thumbs: {
      swiper: productThumbnails,
    },
  });

  productPhotos.on('slideChange', function () {
    productThumbnails.slideTo(productPhotos.activeIndex);
  });

  // products slider
  const productsSlider = new Swiper('.js-productsSlider', {
    slidesPerView: 1,
    breakpoints: {
      '768': {
        slidesPerView: 2,
      },
      '992': {
        slidesPerView: 3,
      },
    },
  });

  // product tabs
  body.on('click', '.product-card__tabs-link', function (e) {
    e.preventDefault();
    const link = $(this);
    const block = link.closest('.product-card__tabs');
    const links = block.find('.product-card__tabs-link');
    const tabs = block.find('.product-card__tab');

    if (link.hasClass('product-card__tabs-link--active')) return false;

    links.not(link).removeClass('product-card__tabs-link--active');
    link.addClass('product-card__tabs-link--active');
    tabs.hide();
    tabs.eq(link.index()).show();
  });

  // quantity field
  body.on('click', '.quantity__button', function (e) {
    e.preventDefault();
    const button = $(this);
    const field = button.closest('.quantity');
    const type = button.data('type');
    const input = field.find('.quantity__input');
    const inputValue = parseInt(input.val(), 10);
    const inputUnit = input.data('unit');

    if (type === 'less') {
      input.val(`${Math.max(0, inputValue - 1)} ${inputUnit}`);
    } else {
      input.val(`${inputValue + 1} ${inputUnit}`);
    }
  });

  body.on('focus', '.quantity__input', function () {
    $(this).val(parseInt($(this).val(), 10));
  });

  body.on('blur', '.quantity__input', function () {
    const unit = $(this).data('unit');
    const value = $(this).val();
    $(this).val(`${value ? value : 1} ${unit}`);
  });

  body.on('input', '.quantity__input', function () {
    const value = $(this).val().replace(/[^0-9]/g, "");

    $(this).val(value);
  });

  // product tile
  body.on('mouseover', '.js-productPreview', function () {
    const element = $(this);
    const url = element.data('src');
    const tile = element.closest('.product-tile');
    const photo = tile.find('.product-tile__photo');
    const lines = tile.find('.product-tile__line');

    photo.css('background-image', `url(${url})`);
    lines.removeClass('product-tile__line--active');
    lines.eq(element.index()).addClass('product-tile__line--active');
  });

  body.on('click', '.js-productLine', function (e) {
    e.preventDefault();
    const element = $(this);
    const tile =  element.closest('.product-tile');
    const url = tile.find('.product-tile__area').eq(element.index()).data('src');
    const photo = tile.find('.product-tile__photo');
    const lines = tile.find('.product-tile__line');

    photo.css('background-image', `url(${url})`);
    lines.not(element).removeClass('product-tile__line--active');
    element.addClass('product-tile__line--active');
  });

  body.on('click', '.compare-link', function (e) {
    e.preventDefault();
    const link = $(this);
    const productId = link.data('id');
    // do something
  });

  body.on('click', '.favorite-link', function (e) {
    e.preventDefault();
    const link = $(this);
    const productId = link.data('id');

    // do something
  });

  // filter
  body.on('click', '.js-openFilter', function (e) {
    e.preventDefault();
    $('.catalogue__sidebar').fadeIn(200);
  });

  body.on('click', '.js-closeFilter', function (e) {
    e.preventDefault();
    $('.catalogue__sidebar').fadeOut(200);
  });

  body.on('click', '.js-toggleFilterGroup', function (e) {
    e.preventDefault();
    const link = $(this);
    const group = link.closest('.catalogue-filter__group');
    const content = group.find('.catalogue-filter__group-content');

    link.toggleClass('catalogue-filter__group-head--active');
    content.stop(true, true).slideToggle(200);
  });

  body.on('click', '.js-toggleHiddenItems', function (e) {
    e.preventDefault();
    const link = $(this);
    const group = link.closest('.catalogue-filter__group');
    const hidden = group.find('.catalogue-filter__group-hidden');

    link.toggleClass('catalogue-filter__group-more--opened');
    link.text(link.text() === 'Показать все' ? 'Свернуть' : 'Показать все');
    hidden.toggleClass('catalogue-filter__group-hidden--opened');
  });

  const rangeSlider = $('.js-rangeSlider');
  if (rangeSlider.length) {
    rangeSlider.each(function () {
      const slider = $(this).closest('.range');
      const min = parseInt($(this).data('min'), 10);
      const max = parseInt($(this).data('max'), 10);

      $(this).slider({
        range: true,
        min: min,
        max: max,
        values: [ min, max],
        create: function() {
          slider.find('.js-from').val($( this ).slider("values")[0]);
          slider.find('.js-to').val($( this ).slider("values")[1]);
        },
        slide: function( event, ui ) {
          slider.find('.js-from').val(ui.values[ 0 ]);
          slider.find('.js-to').val(ui.values[ 1 ]);
        }
      });
    });
  }

  let range_timeout;
  body.on('input paste', '.js-rangeInput',function () {
    $(this).val($(this).val().replace(/[^0-9]/gim,''));

    const module = $(this).closest('.range');
    const range = module.find('.js-rangeSlider');
    const min = parseInt(range.data('min'), 10);
    const max = parseInt(range.data('max'), 10);
    const input = $(this);

    if (range_timeout) {
      clearTimeout(range_timeout);
    }
    range_timeout = setTimeout(function () {
      if (!input.val().length) input.val(0);

      if (input.hasClass('js-from')) {
        input.val(Math.min(parseInt(module.find('.js-to').val(), 10), parseInt(input.val(),10)));
        input.val(Math.max(min, input.val()));
        range.slider('values', 0, Math.max(range.slider('option', 'min'), input.val()));

      } else {
        input.val(Math.min(max, parseInt(input.val(),10)));
        input.val(Math.max(parseInt(module.find('.js-from').val(), 10), input.val()));
        range.slider('values', 1, Math.min(range.slider('option', 'max'), input.val()));
      }
    }, 800);
  });

  body.on('click', '.js-setRange', function (e) {
    e.preventDefault();
    const link = $(this);
    const module = link.closest('.range');
    const range = module.find('.js-rangeSlider');
    const min = parseInt(link.data('min'), 10);
    const max = parseInt(link.data('max'), 10);

    $('.js-from').val(min)
    $('.js-to').val(max)
    range.slider('values', 0, min);
    range.slider('values', 1, max);
  });

  // custom select
  body.on('click', '.js-select', function (e) {
    e.preventDefault();
    const select = $(this).closest('.custom-select');
    const options = select.find('.custom-select__options');

    if (!select.hasClass('custom-select--opened')) {
      select.addClass('custom-select--opened');
      options.slideDown(200);
    } else {
      select.removeClass('custom-select--opened');
      options.slideUp(200);
    }
  });

  body.on('click', '.js-changeSelect', function (e) {
    e.preventDefault();
    const selected = $(this);
    const select = selected.closest('.custom-select');
    const link = select.find('.custom-select__selected');
    const input = select.find('.custom-select__input');
    const options = $('.custom-select__option');

    if (!selected.hasClass('custom-select__option--selected')) {
      options.not(selected).removeClass('custom-select__option--selected');
      selected.addClass('custom-select__option--selected');
      input.val(selected.data('value'));
      input.trigger('change');
      link.html(selected.text());
      select.removeClass('custom-select--opened');
      select.find('.custom-select__options').slideUp(200);
    }

  });

  body.on('click', function (e) {
    const select = $('.custom-select');
    const options = $('.custom-select__options');

    if (!select.is(e.target) && select.has(e.target).length === 0) {
      options.slideUp(200);
      select.removeClass('custom-select--opened');
    }
  });

  // modals

  function getModal(url, requestData) {
    $.ajax({
      type: 'GET',
      url: url,
      data: requestData,
      success: function (data) {
        body.append(data);
        const modal = $('.custom-modal').last();
        const phoneInput = modal.find('.js-maskedPhone');

        if (phoneInput.length) {
          initPhoneMask(phoneInput[0]);
        }

        openModal(modal);
      }
    });
  }

  function openModal(modal) {
    const scrSize = window.innerWidth;
    const scrAvail = body.innerWidth();
    const padRight = scrSize - scrAvail;

    body.css({
      'overflow': 'hidden',
      'padding-right': `${padRight}px`,
    });

    $(modal).fadeIn(300);
  }

  function closeModal(modal) {
    modal.fadeOut(300);

    setTimeout(function(){
      body.css({
        'overflow': 'visible',
        'padding-right': 0
      });
      modal.remove();
    }, 400);
  }

  body.on('click', function (e) {
    const modal = $('.custom-modal').last();
    const modalDialog = modal.find('.custom-modal__dialog');

    if (modal.is(e.target) || modalDialog.is(e.target)) {
      closeModal(modal);
    }
  });

  body.on('click','.js-closeModal', function (e) {
    e.preventDefault();

    closeModal($(this).parents('.custom-modal'));
  });

  body.on('keydown', function (e) {
    const modal = $('.custom-modal').last();

    if (e.code === 'Escape' && modal.is(':visible')) {
      closeModal(modal);
    }
  });

  body.on('click', '.js-getProjectModal', function (e) {
    e.preventDefault();
    getModal('/ajax/project-modal.php');
  });

  body.on('click', '.js-getRequestModal', function (e) {
    e.preventDefault();
    getModal('/ajax/request-modal.php');
  });

  // compare
  const compare = $('.compare__content');
  if (compare.length) {
    $(window).on('load scroll orientationchange', function () {
      const scrollPos = $(document).scrollTop();
      const tableHead = $('.compare__head');
      const tableHeadHeight = tableHead.outerHeight();
      const productRow = compare.find('.compare__row--product');
      const productRowHeight = compare.find('.compare__row--product').outerHeight();
      const productRowOffset = productRow.offset().top;
      const headerHeight = header.outerHeight();

      if (scrollPos > productRowOffset + productRowHeight - (headerHeight + tableHeadHeight)) {
        if (tableHead.is(':hidden')) tableHead.stop(true, true).fadeIn(200);

      } else {
        if (tableHead.is(':visible')) tableHead.stop(true, true).fadeOut(200);
      }
    });

    $('.compare__table').on('scroll', function () {
      $('.compare__head-inner').scrollLeft($(this).scrollLeft());
    });

    body.on('click', '.js-removeCompareItem', function (e) {
      e.preventDefault();
      const compareTable = $(this).closest('.compare');
      const row = $(this).closest('.compare__properties');
      const index = $(this).closest('.compare__property').index();

      if (row.find('.compare__property').length === 1) {
        document.location.href="/";
      } else {
        compareTable.find('.compare__properties').each(function () {
          $(this).find(`.compare__property:nth-child(${index + 1})`).remove();
        });
      }
    });

    const scrollingContainer = $('.js-horizontalScrolling');
    let isDown = false,
      startX,
      scrollLeft;

    scrollingContainer.find('a').attr('draggable', false);

    scrollingContainer.on('mousedown', function (e) {
      const windowWidth = $(window).width();

      if (windowWidth > 767) {
        isDown = true;
        startX = e.pageX - scrollingContainer.offset().left;
        scrollLeft = scrollingContainer.scrollLeft();
      }
    });

    scrollingContainer.on('mousemove', function (e) {
      if(!isDown) return;
      e.preventDefault();
      const windowWidth = $(window).width();

      if (windowWidth > 767) {
        const x = e.pageX - scrollingContainer.offset().left;
        const walk = x - startX;
        scrollingContainer.scrollLeft(scrollLeft - walk);
      }
    });

    scrollingContainer.on('mouseleave mouseup', function (e) {
      e.preventDefault();
      isDown = false;
    });
  }

  // back top
  $(window).on('load scroll orientationchange', function () {
    const button = $('.back-top');
    if ($(window).scrollTop() > 600 && button.is(':hidden')) {
      button.fadeIn(200);
    }
    if ($(window).scrollTop() <= 600 && button.is(':visible')) {
      button.fadeOut(200);
    }
  });

  body.on('click', '.back-top', function (e) {
    e.preventDefault();

    $('html, body').stop().animate({
      scrollTop: 0
    }, 200);
  });
});
